<script>
  export let entry;
  export let event;
  export let courseInfo;

  const time = t => {
    if (t === "00:00:00.00") {
      return "NT";
    }
    return t;
  };

  let distance, laps;
  $: distance = event.swimstyle.distance;
  $: laps = Array.from(Array(distance / (courseInfo?.distance ?? 25)).keys()).map(
    s => (s + 1) * (courseInfo?.distance ?? 25)
  );
</script>

<style>
  .laps-list {
    list-style: none;
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    padding: 0px;
    margin: 0.5rem;
  }
  .laps-list > li {
    display: flex;
    align-items: flex-end;
  }
  .lap-cnt {
    font-size: 0.6rem;
    display: inline-block;
    width: 30px;
    text-align: right;
  }
  .entry-box {
    width: 3cm;
    height: 0.75cm;
    border: solid black 1px;
    display: inline-block;
    margin-left: 0.2rem;
  }
</style>

<strong>{event.number}
{#if entry.lane}
/{entry.lane}
{/if}
</strong>
<span>{distance}m {event.swimstyle.stroke}</span>
<i>{time(entry.entrytime)}</i>
<ol class="laps-list">
{#each laps as lap}
  <li><span class="lap-cnt">{lap}m</span><div class="entry-box"></div></li>
{/each}
</ol>
